export default function Boolean({formId, boolean, answers, setAnswers}) {
	return (
		<div className={"form-check mb-3"}>
			<input form={formId} type={"checkbox"} id={"mainInfoBoolean" + boolean.id} className={"form-check-input"} checked={answers.booleans.find(value => value.id === boolean.id).checked} onChange={evt => {
				setAnswers(prev => {
					const newState = {...prev};
					const newBooleans = [
						...newState.booleans
					];
					newState.booleans = newBooleans;


					newBooleans.find(value => value.id === boolean.id).checked = evt.target.checked;
					return newState;
				});
			}} />
			<label htmlFor={"mainInfoBoolean" + boolean.id} className={"form-check-label"}>{boolean.name}</label>

		</div>
	);
}
